import Banner from "../CommonComponents/Banner";
import HomeMapSection from "../Components/HomeMapSection";
import HomeWhoAreWe from "../Components/HomeWhoAreWe";
import TnsEmpowering from "../Components/TnsEmpowering";
import TnsNews from "../Components/TnsNews";
import TnsReady from "../Components/TnsReady";
import ContactForm from "../CommonComponents/ContactForm";
import { useState } from "react";
import BookDemoModal from "../Components/BookDemoModal";
function HomePage() {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Banner
        backgroundImage="/assets/home-banner.png"
        label="Empowering Travel"
        heading="Founded by Aviation Professionals. Powered by "
        heading2={" Sabre's Advanced Technology."}
        text={
          <>
            TNS Global brings Sabre's world-class distribution technology to
            travel agencies across 14 African markets — backed by a team
            that has run global aviation and logistics networks, not just sold
            software.
          </>
        }
        buttons={[
          { text: "Explore Solutions", variant: "primary", link: "/resources" },
          {
            text: "Request a Demo",
            variant: "secondary",
            onClick: () => setShowModal(true),
          },
        ]}
        responsive={true}
      />
      <HomeWhoAreWe />
      <TnsEmpowering />
      <HomeMapSection />
      <TnsNews />
      <ContactForm isContactPage={false} />
      <TnsReady />
      <BookDemoModal show={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default HomePage;
